import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { IAxiosDefaultDataObject } from '../../config'
import { Dispatch, UnknownAction } from '@reduxjs/toolkit'
import AdminDynamicCreateOrUpdatePage from '../admin/AdminDynamicCreateOrUpdatePage'
import ItemsApp, { IItemModel } from './ItemsApp'
import { updateItem } from './itemsSlice'
import CreateItemPage from './CreateItemPage'
import { useParams } from 'react-router-dom'
import { AdminPagesService } from '../admin/adminPagesSlice'
import ItemAdditionalDataForm from './ItemAdditionalDataForm'
import DynamicForm from '../../components/Form/DynamicForm'

export default function NewItemPage() {

    const params = useParams()

    const elementsData = DynamicForm.useReturnAllFormsData()
    const singleElemDataValue = (name: string) => DynamicForm.returnSingleFormElementData(itemsApp.elemPrefix + name, elementsData).value


    const itemsApp = new ItemsApp()

    
    const updateItemDetails = (item: IAxiosDefaultDataObject, dispatch: Dispatch<UnknownAction>) => {
        dispatch(updateItem((item as IItemModel)))
    }

    const [categoryTitle, setCategoryTitle] = useState<string>("")

    const handleUpdateSubmitCategoryTitle = (title: string) => {
        setCategoryTitle(title)
    }

    const updateData = (data: IAxiosDefaultDataObject) => {
        let newData = {...data}
        newData.category_title = categoryTitle

        return itemsApp.updateItemSubmitData(newData, singleElemDataValue, categoryTitle)
    }

    if (!params.id){
        return <CreateItemPage />
    }

    return <AdminDynamicCreateOrUpdatePage updateItem={updateItemDetails} addCustomContent={(item) => {
        return <ItemAdditionalDataForm item={(item as IItemModel)} handleUpdateSubmitCategoryTitle={handleUpdateSubmitCategoryTitle} />
    }} updateSubmitData={updateData} />
}